var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.791,
    height: 37.791,
    viewBox: "1379 266.801 37.791 37.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1397.896 266.8c-10.45 0-18.896 8.447-18.896 18.896 0 10.45 8.446 18.896 18.896 18.896 10.449 0 18.895-8.446 18.895-18.896 0-10.449-8.446-18.895-18.895-18.895Zm9.447 25.68-2.664 2.664-6.783-6.783-6.784 6.783-2.664-2.664 6.783-6.784-6.783-6.783 2.664-2.664 6.784 6.783 6.783-6.783 2.664 2.664-6.783 6.783 6.783 6.784Z",
    fill: "#ff5163",
    fillRule: "evenodd",
    "data-name": "Icon material-cancel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.b5a23e52bed779a2f099a2733abc45c6.svg";
export { ForwardRef as ReactComponent };